<template>
	<div id="InventoryTemplate" class="inventory-template">
		<vue-snotify></vue-snotify>
		<div v-if="!showingInventoryTemplate">
			<div v-if="objectInventoryTemplate.id > 0">
				<nav class="navbar navbar-light bg-light">
					<div class="form-inline">
						<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar articulo" v-model="searchProduct">
						<div class="float-right d-none d-sm-inline separator"></div>
						<input class="form-check-input" type="checkbox" value="" id="showInventoriesOnlyCheck" v-model="showInventoriesOnly">
						<label class="form-check-label" for="showInventoriesOnlyCheck">
							Solo Inventariados
						</label>
					</div>
					<div class="form-inline">
					</div>
				</nav>

				<table class="table table-sm table-hover">
					<thead>
						<tr>
							<th>Articulo</th>
							<th v-for="n in 4" :key="n" class="text-center">{{ getEmployeLocal(n) }}</th>
							<th class="text-center">Definitiva</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in inventoryTemplatedetailFilter" :key="index">
							<td class="align-middle">
								<p>{{ item.product.name }}</p>
								<small>Cod: {{ item.product.id }} | ISBN: {{ item.product.isbn }}</small>
							</td>
							<td class="align-middle text-center">
								<input class="input-default text-center" :readonly="updatingInventoryTemplateDetail" v-model="item.count_1" :title="'Actualizado el ' + item.updated_at_1" v-on:keyup.enter="updateCount('1', item)" :disabled="disabledInputCount(item)">
							</td>
							<td class="align-middle text-center">
								<input class="input-default text-center" :readonly="updatingInventoryTemplateDetail" v-model="item.count_2" :title="'Actualizado el ' + item.updated_at_2" v-on:keyup.enter="updateCount('2', item)" :disabled="disabledInputCount(item)">
							</td>
							<td class="align-middle text-center">
								<input class="input-default text-center" :readonly="updatingInventoryTemplateDetail" v-model="item.count_3" :title="'Actualizado el ' + item.updated_at_3" v-on:keyup.enter="updateCount('3', item)" :disabled="disabledInputCount(item)">
							</td>
							<td class="align-middle text-center">
								<input class="input-default text-center" :readonly="updatingInventoryTemplateDetail" v-model="item.count_4" :title="'Actualizado el ' + item.updated_at_4" v-on:keyup.enter="updateCount('4', item)" :disabled="disabledInputCount(item)">
							</td>
							<td class="align-middle text-center">
								<input class="input-default text-center" :readonly="updatingInventoryTemplateDetail" v-model="item.count_end" :title="'Actualizado el ' + item.updated_at_end" v-on:keyup.enter="updateCount('end', item)">
							</td>
							<th class="align-middle">
								<i class="fas fa-history text-info pointer" title="Seguimiento"></i>
							</th>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else class="text-center">
				No se encontró la planilla {{ id }}
			</div>
		</div>
		<div v-else class="text-center">
			Buscando Planilla Nº {{ id }}
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventoryTemplate from '@/mixins/inventories/inventoryTemplate.js'
	import inventoryTemplateDetail from '@/mixins/inventories/inventoryTemplateDetail.js'

	export default {
		name: 'InventoryTemplate',
		mixins: [axiosAction, errors, mixin, inventoryTemplate, inventoryTemplateDetail],
		props: ['id'],
		data() {
			return {
				searchProduct: '',
				showInventoriesOnly: false
			}
		},
		computed: {
			inventoryTemplatedetailFilter() {
				let list = []
				let searchProduct = this.searchProduct.toLowerCase()
				let strings = searchProduct.split('%')
				let r = true
				let index = -1
				list = this.objectInventoryTemplate.inventory_template_detail.filter(e => {
					r = true
					strings.forEach(el => {
						index = e.product.name.toLowerCase().indexOf(el)
						if(index == -1 && r == true) {
							r = false
						}
					})
					if(!r) {
						r = (parseInt(e.product.id) == strings[0] || e.product.isbn == strings[0])
					}
					if(this.showInventoriesOnly && r) {
						r = (e.count_1 != null || e.count_2 != null || e.count_3 != null || e.count_4 != null)
					}
					return r
				})
				return list
			}
		},
		methods: {
			disabledInputCount(item) {
				return (item.count_end > 0)
			},
			getEmployeLocal(n) {
				let name = 'Sin asignar'
				this.objectInventoryTemplate.inventory_template_employee.forEach(e => {
					if(parseInt(e.pivot.count_x) == parseInt(n)) {
						name = e.name.split(' ')[0] + ' ' + e.surname.split(' ')[0]
					}
				});
				return name
			},
			initModuleLocal() {
				this.setTitleModule('Planilla')
				this.setSubTitleModule('')
				this.setModuleLocal()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'showInventoryTemplateResult': this.showInventoryTemplateResult(response); break;
					case 'updateInventoryTemplateDetailResult': this.updateInventoryTemplateDetailResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			setModuleLocal() {
				if(this.id > 0) {
					this.showInventoryTemplate(this.id, 1)
				}
			},
			showInventoryTemplateResultLocal(response) {
				
				if(response.data.success == true) {
					this.setTitleModule(this.objectInventoryTemplate.name + ' (' + this.objectInventoryTemplate.id + ')')
				} else {
					alert('Planilla no encontrada')
				}
			},
			updateInventoryTemplateDetailResultLocal(response) {
				if(response.data.success == true && response.data.message == true) {
					this.$snotify.success('Cantidad actualizada', 'Listo!!!');
				} else {
				}
			}
		},
		components: {
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style scoped lang="scss">
</style>